/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Measure_Unit_Request_PerInputs */

const en_measure_unit_request_per = /** @type {(inputs: Measure_Unit_Request_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per request`)
};

const zh_hans1_measure_unit_request_per = /** @type {(inputs: Measure_Unit_Request_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每次请求`)
};

const pt_br2_measure_unit_request_per = /** @type {(inputs: Measure_Unit_Request_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por requisição`)
};

const es_measure_unit_request_per = /** @type {(inputs: Measure_Unit_Request_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por solicitud`)
};

const fr_measure_unit_request_per = /** @type {(inputs: Measure_Unit_Request_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`par requête`)
};

const de_measure_unit_request_per = /** @type {(inputs: Measure_Unit_Request_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pro Anfrage`)
};

const ru_measure_unit_request_per = /** @type {(inputs: Measure_Unit_Request_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`за запрос`)
};

const it_measure_unit_request_per = /** @type {(inputs: Measure_Unit_Request_PerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`a richiesta`)
};

/**
* | output |
* | --- |
* | "per request" |
*
* @param {Measure_Unit_Request_PerInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const measure_unit_request_per = /** @type {((inputs?: Measure_Unit_Request_PerInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Measure_Unit_Request_PerInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_measure_unit_request_per(inputs)
	if (locale === "pt-BR") return pt_br2_measure_unit_request_per(inputs)
	if (locale === "es") return es_measure_unit_request_per(inputs)
	if (locale === "fr") return fr_measure_unit_request_per(inputs)
	if (locale === "de") return de_measure_unit_request_per(inputs)
	if (locale === "ru") return ru_measure_unit_request_per(inputs)
	if (locale === "it") return it_measure_unit_request_per(inputs)
	return en_measure_unit_request_per(inputs)
});